<template>
  <Modal :title="status ? 'ぐるなび予約連携方式の切替' : '認証キーの登録'" @close="close" size="big">
    <LoadingIndicator v-if="busy" />
    <template>
      <template v-if="!status">
        ぐるなびネット予約の予約管理画面で認証キーを発行し、以下に認証キーを入力します。連携方式を選択し、登録してください。
      </template>
      <template v-else>ぐるなびネット予約連携方式の切替を行います。連携方式を選択してください。</template>
      <div v-if="!status" class="auth-key">
        <TextInput placeholder="認証キー" v-model.trim="authKey" />
      </div>
      <div v-else class="caution">
        連携方式の切替には予約件数により時間がかかる場合があります。 <br />
        切替中は台帳が操作できませんので営業時間外での切替をおすすめします。
      </div>
      <div class="sync-type">
        <div class="radio">
          <RadioButton value="2" v-model.number="inputValue">
            ぐるなび台帳とぐるなびネット予約を相互連携する
          </RadioButton>
          <GnaviSyncInteractiveIcon class="icon" width="360" height="100" />
          <p class="text">
            ぐるなびネット予約と双方向での連携になりますので、台帳に登録した予約が予約管理に予定として登録され、在庫管理に最適です。<br />
            台帳で登録したテーブルを予約受付設定に登録することで、ぐるなびネット予約に連携され、予約ページに表示されます。
          </p>
        </div>
        <div class="radio">
          <RadioButton value="1" v-model.number="inputValue">
            ぐるなびネット予約から連携のみ受け付ける
          </RadioButton>
          <GnaviSyncIcon class="icon" width="360" height="100" />
          <p class="text">
            ぐるなびネット予約からの予約連携を受け付けるのみになりますので、<br />
            ぐるなび予約からの連携された予約はテーブル未設定として台帳に連携されます。
          </p>
        </div>
      </div>
    </template>

    <template #footer-center>
      <Button @click="close">戻る</Button>
      <Button v-if="!status" primary @click="save" :disabled="!authKey">登録</Button>
      <Button v-else primary @click="save" :disabled="inputValue === type">切替</Button>
    </template>
  </Modal>
</template>
<script>
import { mapState } from 'vuex'
import Modal from '@/components/molecules/Modal'
import Button from '@/components/atoms/Button'
import RadioButton from '@/components/atoms/RadioButton'
import TextInput from '@/components/atoms/TextInput'
import GnaviSyncInteractiveIcon from '@/components/icons/gnaviSyncInteractive'
import GnaviSyncIcon from '@/components/icons/gnaviSync'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'

export default {
  name: 'GnaviSyncSettingModal',
  components: {
    Modal,
    Button,
    RadioButton,
    TextInput,
    GnaviSyncInteractiveIcon,
    GnaviSyncIcon,
    LoadingIndicator,
  },
  props: {
    status: { type: Number, required: true },
    type: { type: Number, required: true },
  },
  data() {
    return {
      inputValue: this.type || 2,
      authKey: '',
    }
  },
  computed: {
    ...mapState({
      busy: state => state.stores.gnaviStart.busy,
    }),
  },
  methods: {
    close() {
      this.$emit('close')
    },
    save() {
      this.$emit('save', { collaborationType: this.inputValue, collaborationKey: this.authKey })
    },
  },
}
</script>

<style lang="postcss" scoped>
.sync-type {
  display: grid;
  grid-gap: 24px;
  padding-top: 8px;
}

.radio {
  display: grid;
  grid-gap: 8px;
  > p {
    font-size: 13px;
  }
}

.radio-button {
  color: var(--very-dark-gray-2);
}

.auth-key {
  > input {
    height: 48px;
  }
}

.caution {
  background: var(--very-pale-red);
  color: var(--pure-red);
  padding: 16px;
  text-align: center;
}

.icon {
  justify-self: center;
}

.text {
  font-size: 13px;
  padding: 0 48px;
}
</style>
